export const settings = [
  { title: '企业经营类别', desc: '维护企业经营类别，如：化妆品、汽车等', topic: 'sgs', k: 'company_business_category', componentName: 'CompanyBusinessCategoryCard' },
  { title: '企业品牌形象', desc: '维护企业品牌形象，如：龙头企业、500强等', topic: 'sgs', k: 'company_brand_image', componentName: 'CompanyBrandImageCard' }
]
